/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import styles from './index.styl';

const SectionTitle = ({ text }) => (
  <p styleName="section-title" children={text} />
);

SectionTitle.propTypes = {
  text: PropTypes.string,
};

export default CSSModules(SectionTitle, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/Community/SectionTitle.jsx